import axios from "axios";
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import OtherInfo from "./OtherInfo";

function OtpModal({ isOpen, onClose, email,userType }) {
  const [isOtherInfoOpen, setIsOtherInfoOpen] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]); // 6 digit OTP
  const [loadingResend, setLoadingResend] = useState(false);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(120);
  const navigate = useNavigate();
  const inputRefs = useRef([]);
  


   // ⏳ Start countdown when modal opens
  useEffect(() => {
    let countdown;
    if (isOpen && timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);
    }
    return () => clearInterval(countdown);
  }, [isOpen, timer]);

  // 🕐 Format timer (MM:SS)
  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  };
  // 🔹 Handle OTP input
  const handleOtpChange = (value, index) => {
    if (/^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

       if (value && index < otp.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };
const closeOtherInfo = () => {
    setIsOtherInfoOpen(false);
    onClose();
  };
  
  if (!isOpen && !isOtherInfoOpen) return null;

  // Verify OTP API call
const handleVerifyOtp = async () => {
  
    const otpCode = otp.join("").trim();
    if (otpCode.length !== 6) {
      toast.error("Please enter a valid 6-digit OTP");
       if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
      return;
    }

    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/user/verify-otp`,
        { email, otp: otpCode }
      );

      if (res.data?.token && res.data?.user) {

         const expiresIn = 60 * 60 * 1000;
      const expiryTime = Date.now() + expiresIn;
      const wishlist = res.data.wishlist_ids
        // Store token & user in localStorage
         localStorage.setItem("expiry", expiryTime.toString());
        localStorage.setItem("authToken", res.data.token);
        localStorage.setItem("user", JSON.stringify(res.data.user));
        localStorage.setItem("userWishlist", JSON.stringify(wishlist));
        const currencyData = {
    id: res.data.user.currency_id,
    country_name: res.data.user.country_name,
    currency: res.data.user.currency,
    symbol: res.data.user.symbol,
    exchanged_sgd_rate: res.data.user.exchanged_sgd_rate,
  };

  localStorage.setItem("selectedCurrency", JSON.stringify(currencyData));
 

        // 🚀 Check signup status
        if (res.data.signup_complete_status === "0") {
          // Open OtherInfo modal for additional details
          setIsOtherInfoOpen(true);
        } else {
           onClose();
          // Navigate based on userType

          // ✅ Check if Review page has pending hid/eid
      const pendingHid = localStorage.getItem("pendingHid");
      const pendingEid = localStorage.getItem("pendingEid");

      if (pendingHid && pendingEid) {
       
        toast.success("Login successful");
        localStorage.removeItem("pendingHid");
    localStorage.removeItem("pendingEid");
        onClose(); // 🔹 Close OTP modal directly
        return;
      }
          
          if (res.data.user.user_type === 2 && res.data.user.host_profile === 1) {
            navigate("/listing");
          } else if (res.data.user.user_type === 2 && res.data.user.host_profile === 0) {
            navigate("/host-category");
          } else  {
            navigate("/profile");
          }
        }
      } else {
       toast.error(res.data?.message || "Invalid OTP");
       
        if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
      }
    } catch (err) {
      console.error("OTP verify error:", err);
       const errMsg = err.response?.data?.message || "Something went wrong while verifying OTP.";
      toast.error(errMsg);
       if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
    } finally {
      setLoading(false);
    }
  };


  //  Resend OTP API call
  const handleResendOtp = async () => {
     if (timer > 0) return; // prevent early resend
    try {
      setLoadingResend(true);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/user/resend-otp`,
        { email } // must send email
      );

      if (res.data && res.data.status) {
        toast.success("OTP Sent Again!");
         setTimer(120); // restart timer
      } else {
        toast.error(res.data.message || "Failed to resend OTP");
      }
    } catch (err) {
      console.error("Resend OTP error:", err);
       const errMsg =
      err?.response?.data?.message ||
      err?.response?.data?.msg ||
      err.message ||
      "Something went wrong while resending OTP.";

    toast.error(errMsg);

    // 🕐 Extract time from backend message (e.g. "after 04:11 minutes")
    const match = errMsg.match(/after (\d{2}):(\d{2})/);
    if (match) {
      const minutes = parseInt(match[1], 10);
      const seconds = parseInt(match[2], 10);
      setTimer(minutes * 60 + seconds);
    }
    } finally {
      setLoadingResend(false);
    }
  };

  // const closeOtherInfo = () => {
  //   setIsOtherInfoOpen(false);
  // };

  return (
    <>
      {/* OTP Modal */}
      {isOpen && (
        <div className="modal fade all_modalss show" style={{ display: "block" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content detailspgess">
              <div className="modal-header">
                <button type="button" className="close" onClick={onClose}>
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div className="shedow_booox">
                  <div className="al_titlss_ara">
                    <h3>
                      <Link className="ar_left"  onClick={(e) => {
    e.preventDefault();
    onClose();
  }}>
                        <img src="images/chevron-left.png" alt="" />
                      </Link>{" "}
                      Confirm Your Email
                    </h3>
                    <p className="discrpss">
                      Enter the code we’ve sent to {email}
                    </p>
                  </div>

                  {/* OTP Inputs */}
                  <div className="form-group in_manages">
                    {otp.map((digit, i) => (
                      <input
                        key={i}
                        type="text"
                        className="form-control"
                        maxLength="1"
                        value={digit}
                        ref={(el) => (inputRefs.current[i] = el)}
                        onChange={(e) => handleOtpChange(e.target.value, i)}
                         onKeyDown={(e) => {
    if (e.key === "Backspace" && !otp[i] && i > 0) {
      inputRefs.current[i - 1].focus(); // ✅ Move back
    }
  }}
                        onPaste={(e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData("text").trim().slice(0, 6); // Take max 6 digits
        const newOtp = [...otp];
        for (let j = 0; j < pasteData.length; j++) {
          if (/^\d$/.test(pasteData[j])) newOtp[j] = pasteData[j];
        }
        setOtp(newOtp);
         const lastIndex = Math.min(pasteData.length - 1, otp.length - 1);
                          inputRefs.current[lastIndex].focus();
      }}
                      />
                    ))}
                  </div>

                  {/* Resend link */}
                  <div className="txtxtx">
                    {/* Haven’t received code ?{" "}
                    <a  onClick={handleResendOtp}>
                      {loadingResend ? "Sending..." : "Send again"}
                    </a> */}
                    {timer > 0 ? (
                      <span>
                        Resend OTP in <strong>{formatTime(timer)}</strong>
                      </span>
                    ) : (
                      <>
                      Haven’t received code ?{" "}
                      <a onClick={handleResendOtp}>
                        {loadingResend ? "Sending..." : "Send again"}
                      </a>
                      </>
                    )}
                  </div>

                  <div className="form-group">
                    <button
                      className="btnlinks"
                      type="button"
                      onClick={handleVerifyOtp}
                      disabled={loading}
                    >
                      {loading ? "Verifying..." : "Continue"}
                    </button>
                  </div>

                 
                </div>
              </div>
            </div>
          </div>

          {/* Background overlay */}
          <div className="modal-backdrop fade show" onClick={onClose}></div>
        </div>
      )}

      {/* Other Info Modal */}
      {isOtherInfoOpen && (
        <OtherInfo isOpen={isOtherInfoOpen} onClose={closeOtherInfo} userType={userType} />
      )}
    </>
  );
}

export default OtpModal;
